<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'forms.account-password.newPassword' | translate }}</mat-label>
            <input
                name="password"
                type="password"
                required
                [formControl]="password"
                (ngModelChange)="validatePasswords()"
                matInput
            />
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{ 'forms.account-password.confirmPassword' | translate }}</mat-label>
            <input
                name="confirm-password"
                type="password"
                required
                [formControl]="confirmPassword"
                (ngModelChange)="validatePasswords()"
                matInput
            />
        </mat-form-field>
        <div class="validation-items">
            <div class="validation-item" [class.valid]="hasUpperCase">
                <mat-icon svgIcon="success"></mat-icon>
                <p>{{ 'forms.account-password.uppercaseCharacter' | translate }}</p>
            </div>
            <div class="validation-item" [class.valid]="hasLowerCase">
                <mat-icon svgIcon="success"></mat-icon>
                <p>{{ 'forms.account-password.lowercaseCharacter' | translate }}</p>
            </div>
            <div class="validation-item" [class.valid]="hasNumber">
                <mat-icon svgIcon="success"></mat-icon>
                <p>{{ 'forms.account-password.number' | translate }}</p>
            </div>
            <div class="validation-item" [class.valid]="hasMinimumCharacters">
                <mat-icon svgIcon="success"></mat-icon>
                <p>{{ 'forms.account-password.characterMinimum' | translate }}</p>
            </div>
            <div class="validation-item" [class.valid]="passwordsMatch">
                <mat-icon svgIcon="success"></mat-icon>
                <p>{{ 'forms.account-password.passwordsMatch' | translate }}</p>
            </div>
        </div>
    </div>
</form>
